import React from "react";
import Preloader from "../../Global/Preloader";
import Header from "../../Global/Header";
import BredCrumb from "../../Global/BredCrumb";
import BlogDetail from "../MenSingleBlog/BlogDetail";
import Comment from "../MenSingleBlog/Comment";
import CommentForm from "../MenSingleBlog/CommentForm";
import Call from "../../Menhomeone/Call";
import Footer from "../../Global/Footer";
import GoToTop from "../../Global/GoToTop";
const Main = () => {
    return (
        <> 
            <Preloader/>
            <Header />
            <BredCrumb Title="Latest Blog Post" subtitle="Blog Detail" />
            <div className="page_wrapper blog_dt">
                <BlogDetail />
                <Comment />
                <CommentForm/>
                <Call/>
                <Footer/>
                <GoToTop/>
            </div>

        </>

    )
}
export default Main;